
import { component } from '@/helpers/vueTyped';

export default component()({
  name: 'App',

  functional: true,

  render() {
    return (
      <div class='app'>
        <transition name='fade' mode='out-in'>
          <keep-alive>
            <router-view class='app-view'/>
          </keep-alive>
        </transition>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-71c42a7e/App.vue" });